import { render, staticRenderFns } from "./list.vue?vue&type=template&id=20fcb44d"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20fcb44d')) {
      api.createRecord('20fcb44d', component.options)
    } else {
      api.reload('20fcb44d', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=20fcb44d", function () {
      api.rerender('20fcb44d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/contact-list/contacts/list.vue"
export default component.exports